export interface DataEntity_Detail_04_Interface {
    id: number,
    main_id: number,
  
    marking: string,
    nominal : string,
    found: string,
    left: string,
    uncertainty : string,
    converage : string,
    status: number,

    before:boolean,
  }
  
  export function Empty_DataEntity_Detail_04_Interface(): DataEntity_Detail_04_Interface {
    return {
      id: 0,
      main_id: 0,
      status: 0,

      marking: '',
      nominal : '',
      found: '',
      left: '',
      uncertainty : '',
      converage: '',

      before:false
    }
  }